<template>
  <div>
    <a-card :bordered="false" size="small">
      <div class="flex book-part">
        <div class="basic-box">
          <span><strong>SIG_USA</strong></span>
          <span><strong>342550</strong></span>
          <span class="date">07/06/2021</span>
          <span>Group No.<span><a class="link-btn" @click="handleEditBookGroup">1</a></span></span>
        </div>
        <div class="flex-1 update">
          <img alt="" src="@/assets/star.svg" class="icon-box">
          <span style="text-decoration: underline;padding-left: 4px;">Update: </span><span>(06/29/2021)</span>
        </div>
      </div>
      <div>
        <basic-steps/>
      </div>
    </a-card>
    <a-modal
        title="Edit Group No"
        :visible="bookGroupVisible"
        :maskClosable="false"
        @cancel="handleBookGroupCancel"
      >
        <div>
          <a-form layout='vertical' :form="formGroupNo">
            <a-form-item label='Group No'>
              <a-input/>
            </a-form-item>
          </a-form>
        </div>
        <div slot="footer">
          <a-row type="flex" justify="end">
            <a-col :xs="9" :md="5">
              <a-popconfirm
                title="Are you sure?"
                @confirm="handleDepositOk"
                ok-text="Yes" 
                cancel-text="No"
              >
                <a-button type="primary">Confirm</a-button>
              </a-popconfirm>	
            </a-col>
          </a-row>
        </div>
      </a-modal>
  </div>
</template>

<script>
// import pick from 'lodash.pick'
import BasicSteps from './booksteps/BookBasicSteps'

export default {
  name: 'BookBasicMain',
  components: {
    BasicSteps
  },
  props: {
  },
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 24 }
        }
      },
      bookGroupVisible: false,
      formGroupNo: this.$form.createForm(this)
    }
  },
  mounted () {
  },
  methods: {
    handleEditBookGroup () {
      this.bookGroupVisible = true
    },
    handleBookGroupCancel () {
      this.bookGroupVisible = false
    },
    handleDepositOk () {
    }
  }
}
</script>
<style lang="less" scoped>
.basic-box {
  color: #000;
}
.basic-box > span {
  padding-right: 12px;
}
.update {
  text-align: right;
}
.icon-box {
  width: 18px;
}
</style>